module.exports = "https://jsak.mmtcdn.com/tripmoney/static/media/DOCTOR'S SBI CARD (IMA).92ea89c6.png";